import ChannelContext from '@jetshop/core/components/ChannelContext';
import React, { useContext } from 'react';
import useChannelCheck from '../../hooks/useChannelCheck';
import { styled } from 'linaria/react';
import { useIntl } from '@jetshop/intl';
import { theme } from '../../Theme';

const RecommendedPriceWrapper = styled('div')`
  margin-top: 0.3rem;
  p {
    color: #00000066;
    font-size: 1rem;
  }

  .small {
    font-size: 11px;
    line-height: 12px;
  }

  ${theme.below.lg} {
    p {
      text-align: right;
    }
  }
`;

export const RecommendedPrice = ({ product }) => {
  const { isB2B } = useChannelCheck();
  const { selectedChannel } = useContext(ChannelContext);
  const b2bRecommendedPrice = product?.customFields?.find(
    customField => customField?.key === 'msrp'
  )?.stringValue;
  const t = useIntl();
  const rrpString = t('Recommended retail price');

  if (!isB2B || !b2bRecommendedPrice) {
    return null;
  }

  const isSoumi = selectedChannel?.country?.code === 'FI';

  const prefix =
    selectedChannel?.currency?.name === 'SEK' ? '' : isSoumi ? '' : '€ ';
  const suffix =
    selectedChannel?.currency?.name === 'SEK' ? ' :-' : isSoumi ? ' €' : '';

  return (
    <RecommendedPriceWrapper>
      <p className="small">{rrpString}</p>
      <p>
        {prefix}
        {b2bRecommendedPrice}
        {suffix}
      </p>
    </RecommendedPriceWrapper>
  );
};
